.file_progress {

    :global(.ant-progress-indicator) {
        color: #fff !important;
    }
}